export default {
  'meta': {
    'langName': 'LITHUANIAN',
    'lang': 'Lietuvių'
  },
  'title': ' „TARMAK“ KREPŠINIO LANKO STOVO „B900 BOX NBA“ GAMINIO ATŠAUKIMAS',
  'description': 'Nustatėme, kad mūsų „B900“ krepšinio lanko stovas gali nukristi, jei jį naudosite ar reguliuosite be aukščio reguliavimo rankenos.\n\nJūsų saugumui, nedelsdami nustokite naudoti gaminį, jei aukščio reguliavimo rankena nėra tinkamai pritvirtinta.\n\nSavo gaminį galėsite lengvai vėl padaryti saugų pasinaudoję remonto rinkiniu, kurį jums išsiųsime nemokamai.\n\nŠiuo metu kuriame specialią svetainę šiam gaminio atšaukimui. Joje rasite nuoseklias instrukcijas, kaip atlikti būtiną saugos korekciją.\nInformuosime jus, kai tik svetainė bus pasiekiama (liepos mėnesį).',
  'status': 'Translation validated by COUNTRY'
} as const
